export const ADD_INGREDIENT = "ADD_INGREDIENT";
export const REMOVE_INGREDIENT = "REMOVE_INGREDIENT";
export const FINISH_PURCHASING = "FINISH_PURCHASING";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const UPDATE_SODA_CHOICE = "UPDATE_SODA_CHOICE";
export const UPDATE_Fries_CHOICE = "UPDATE_Fries_CHOICE";
export const NONE_SELECTED = "NONE_SELECTED";